<cinematic (onClose)="handleClose()">
    <cinematic_custom-header>
        <div class="log-cinematic__header">
            <div class="log-cinematic__header-top">
                {{ vsName$ | async }} {{ globalL10nKeys.logLabel | vtranslate }}
            </div>
            <ng-container *ngrxLet="busy$ as busy">
                <div class="log-cinematic__header-main">
                    <h2 class="log-cinematic__header-text">
                        <ng-container *ngIf="!busy; else logLabelOnly">
                            {{ (logTypeLabel$ | async | vtranslate) }} {{ globalL10nKeys.logLabel | vtranslate }}
                        </ng-container>
                        <ng-template #logLabelOnly>
                            {{ globalL10nKeys.logLabel | vtranslate }}
                        </ng-template>
                    </h2>
                    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.L7">
                        <ng-container *ngrxLet="wafStatus$ as wafStatus">
                            <button
                                type="button"
                                class="log-cinematic__header-btn"
                                *ngIf="wafStatus === 'FLAGGED' || wafStatus === 'REJECTED'"
                                [disabled]="busy"
                                (click)="openRecommendationDialog()"
                            >
                                <cds-icon
                                    class="log-cinematic__header-icon"
                                    [ngClass]="{ 'log-cinematic__header-icon--deactivated': busy }"
                                    shape="recommendation"
                                    size="sm"
                                    [status]="!busy && 'info'"
                                ></cds-icon>
                            </button>
                        </ng-container>
                    </ng-container>
                    <button
                        type="button"
                        class="log-cinematic__header-btn"
                        [disabled]="busy"
                        (click)="downloadLog()"
                    >
                        <cds-icon
                            class="log-cinematic__header-icon"
                            [ngClass]="{ 'log-cinematic__header-icon--deactivated': busy }"
                            shape="download"
                            size="sm"
                            [status]="!busy && 'info'"
                        ></cds-icon>
                    </button>
                    <!-- TODO: to be addressed in AV-153259 -->
                    <button
                        type="button"
                        class="log-cinematic__header-btn"
                        [disabled]="busy"
                        (click)="printLog()"
                    >
                        <cds-icon
                            class="log-cinematic__header-icon"
                            [ngClass]="{ 'log-cinematic__header-icon--deactivated': busy }"
                            shape="printer"
                            size="sm"
                            [status]="!busy && 'info'"
                        ></cds-icon>
                    </button>
                </div>
                <div class="log-cinematic__header-subtitle">
                    <log-cinematic-selection-bar
                        [timestamp]="timestamp$ | async"
                        [hasPrevious]="hasPreviousLog$ | async"
                        [hasNext]="hasNextLog$ | async"
                        [busy]="busy"
                        (onPreviousClick)="switchToPreviousLog()"
                        (onNextClick)="switchToNextLog()"
                    ></log-cinematic-selection-bar>
                </div>
            </ng-container>
        </div>
    </cinematic_custom-header>

    <cinematic_errors>
        <logs-errors
            *ngIf="listLoadingErrored$ | async"
            errorMessage="{{ l10nKeys.errorMsgLabel | vtranslate }}"
            [closable]="false"
        ></logs-errors>
    </cinematic_errors>

    <div
        *ngIf="logListIsLoading$ | async"
        class="log-cinematic__loader-container"
    >
        <span class="spinner spinner-md"></span>
    </div>

    <ng-container *ngIf="!(busy$ | async)">
        <ng-container *ngrxLet="vsAppProfileType$ as vsAppProfileType">
            <!----------------------------------- Top Info Section ---------------------------------->
            <!-- TODO: remove this store data validation workaround with AV-246196 -->
            <ng-container *ngIf="vsAppProfileType$ | async">
                <log-cinematic-top-info></log-cinematic-top-info>
            </ng-container>

            <!------------------------------------- Tab Sections ------------------------------------>

            <!-- Significance Section -->
            <cinematic-tab-section
                *ngIf="significance$ | async"
                [tabTitle]="l10nKeys.significanceLabel | vtranslate"
            >
                <log-cinematic-section-wrapper
                    [header]="l10nKeys.significanceLabel | vtranslate"
                    icon="lightbulb"
                >
                    <log-significance
                        [significantLog]="significantLog$ | async"
                        (onFilterAdd)="trafficLogCinematicStore.closeCinematic()"
                    ></log-significance>
                </log-cinematic-section-wrapper>
            </cinematic-tab-section>

            <!-- Summary Section -->
            <cinematic-tab-section
                *ngIf="vsAppProfileType$ | async"
                [tabTitle]="globalL10nKeys.summaryLabel | vtranslate"
            >
                <log-cinematic-section-wrapper
                    [header]="globalL10nKeys.summaryLabel | vtranslate"
                    icon="details"
                >
                    <log-cinematic-section-summary></log-cinematic-section-summary>
                </log-cinematic-section-wrapper>
            </cinematic-tab-section>

            <!-- L4 Log only sections -->
            <ng-container *ngIf="vsAppProfileType === VsAppProfileType.L4">
                <!-- Client Connection Section -->
                <cinematic-tab-section
                    *ngIf="l4ClientConnectionInfo$ | async"
                    [tabTitle]="l10nKeys.clientConnectionLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="l10nKeys.clientConnectionLabel | vtranslate"
                        icon="display"
                    >
                        <log-cinematic-section-connection
                            [l4ConnectionType]="L4ConnectionType.CLIENT"
                        ></log-cinematic-section-connection>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Server Connection Section -->
                <cinematic-tab-section
                    *ngIf="l4ServerConnectionInfo$ | async"
                    [tabTitle]="l10nKeys.serverConnectionLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="l10nKeys.serverConnectionLabel | vtranslate"
                        icon="host"
                    >
                        <log-cinematic-section-connection
                            [l4ConnectionType]="L4ConnectionType.SERVER"
                        ></log-cinematic-section-connection>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>
            </ng-container>

            <!-- L7 Log only sections -->
            <ng-container *ngIf="vsAppProfileType === VsAppProfileType.L7">
                <!-- SSL Section -->
                <cinematic-tab-section
                    *ngIf="ssl$ | async"
                    [tabTitle]="l10nKeys.sslLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="l10nKeys.sslLabel | vtranslate"
                        icon="key"
                    >
                        <log-cinematic-section-ssl></log-cinematic-section-ssl>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Application Section -->
                <cinematic-tab-section
                    *ngIf="applicationInfo$ | async"
                    [tabTitle]="l10nKeys.applicationLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="l10nKeys.applicationLabel | vtranslate"
                        icon="application"
                    >
                        <log-cinematic-section-application></log-cinematic-section-application>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Protocol Section -->
                <cinematic-tab-section
                    *ngIf="grpcInfo$ | async"
                    [tabTitle]="globalL10nKeys.protocolLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="globalL10nKeys.protocolLabel | vtranslate"
                        icon="application"
                    >
                        <log-cinematic-section-protocol></log-cinematic-section-protocol>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Headers Section -->
                <cinematic-tab-section
                    *ngIf="(httpRequestHeaders$ | async) || (httpResponseHeaders$ | async)"
                    [tabTitle]="globalL10nKeys.headersLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="globalL10nKeys.headersLabel | vtranslate"
                        icon="details"
                    >
                        <log-cinematic-section-headers></log-cinematic-section-headers>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Authentication Section -->
                <cinematic-tab-section
                    *ngIf="hasAuthenticationLogs$ | async"
                    [tabTitle]="globalL10nKeys.authenticationLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="globalL10nKeys.authenticationLabel | vtranslate"
                        icon="details"
                    >
                        <log-cinematic-section-authentication></log-cinematic-section-authentication>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Security Section -->
                <cinematic-tab-section
                    *ngIf="(icapLog$ | async) || (wafLog$ | async) || (botManagementLog$ | async)"
                    [tabTitle]="globalL10nKeys.securityLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="globalL10nKeys.securityLabel | vtranslate"
                        icon="shield"
                    >
                        <log-cinematic-section-security></log-cinematic-section-security>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>

                <!-- Out of Band Section -->
                <cinematic-tab-section
                    *ngIf="oobDsRequestLogs$ | async"
                    [tabTitle]="l10nKeys.outOfBandLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="l10nKeys.outOfBandLabel | vtranslate"
                        icon="bolt"
                    >
                        <log-cinematic-section-out-of-band></log-cinematic-section-out-of-band>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>
            </ng-container>

            <!-- DNS Log only sections -->
            <ng-container *ngIf="vsAppProfileType === VsAppProfileType.DNS">
                <!-- DNS Section -->
                <cinematic-tab-section
                    *ngIf="(dnsRequestInfo$ | async) || (dnsResponseInfo$ | async)"
                    [tabTitle]="globalL10nKeys.dnsLabel | vtranslate"
                >
                    <log-cinematic-section-wrapper
                        [header]="globalL10nKeys.dnsLabel | vtranslate"
                        icon="network-globe"
                    >
                        <log-cinematic-section-dns></log-cinematic-section-dns>
                    </log-cinematic-section-wrapper>
                </cinematic-tab-section>
            </ng-container>

            <!-- Datascript Section -->
            <cinematic-tab-section
                *ngIf="datascriptInfo$ | async"
                [tabTitle]="l10nKeys.datascriptLabel | vtranslate"
            >
                <log-cinematic-section-wrapper
                    [header]="l10nKeys.datascriptLabel | vtranslate"
                    icon="code"
                >
                    <log-cinematic-section-datascript></log-cinematic-section-datascript>
                </log-cinematic-section-wrapper>
            </cinematic-tab-section>
        </ng-container>
    </ng-container>
</cinematic>
